<template>

	<div class="project-slider" dir="ltr">
		<LightGallery
		:images="images"
		:index="index"
		:disable-scroll="true"
		@close="index = null"
		background="rgba(36, 140, 204, 0.8)"
		interfaceColor="rgba(255, 255, 255, 1)"
		/>
		<div v-masonry origin-left="false" transition-duration="1s" item-selector=".item" class="columns">
			<div v-masonry-tile class="item column is-3 p5 card-with-hover-project" v-for="(item, thumbIndex) in images">
				<img :src="item" class="card image-cover hvr-grow" :key="thumbIndex" @click="index = thumbIndex">
			</div>
		</div>
	</div>
</template>
<script>
	import { LightGallery } from 'vue-light-gallery';
	export default {
		name: 'ProjectSlider',
		components: {
			LightGallery,
		},
        props: {
            images: {
                required: true
            },

        },
		data() {
			return {
				index: null,
			}
		},
	};
</script>
